import { ArrowRight, Lock } from "lucide-react";
import { toast } from "sonner";
import { Chapter, Stagger, StaggerItem } from "@/components/Reveal";
import { useLang } from "@/i18n";

const Programs = () => {
  const { t } = useLang();
  const p = t.programs;

  const buy = (title) =>
    toast.info(p.toastTitle, { description: p.toastBody(title) });

  return (
    <section id="programs" data-testid="programs-section" className="py-24 md:py-32">
      <div className="container-x">
        <Chapter num="03" label={p.chapter} />

        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-7xl uppercase tracking-tight leading-[0.9]">
              {p.titleA} <span className="text-[#D91624]">{p.titleB}</span>
            </h2>
            <p className="mt-6 max-w-2xl text-base md:text-lg text-neutral-400 leading-relaxed">
              {p.intro}
            </p>
          </div>
        </div>

        <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {p.items.map((prog) => (
            <StaggerItem key={prog.id}>
              <article
                data-testid={`program-card-${prog.id}`}
                className="group h-full bg-[#121212] border border-white/10 flex flex-col hover:border-[#D4AF37]/40 transition-colors duration-500"
              >
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={prog.img}
                    alt={prog.title}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/30" />
                  <span
                    className={`absolute top-4 left-4 text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5 ${
                      prog.status === "available"
                        ? "bg-[#D91624] text-white"
                        : "bg-neutral-800 text-neutral-400"
                    }`}
                  >
                    {prog.status === "available" ? p.available : p.coming}
                  </span>
                </div>

                <div className="p-6 flex flex-col grow">
                  <p className="overline-gold !text-[10px]">{prog.subtitle}</p>
                  <h3 className="font-display text-2xl md:text-3xl uppercase mt-2 leading-tight">
                    {prog.title}
                  </h3>
                  <p className="mt-3 text-sm text-neutral-400 leading-relaxed grow">
                    {prog.description}
                  </p>
                  <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-4">
                    <span className="font-display text-2xl text-white">{prog.price}</span>
                    {prog.status === "available" ? (
                      <button
                        data-testid={`program-buy-${prog.id}`}
                        onClick={() => buy(prog.title)}
                        className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#D91624] hover:text-white transition-colors duration-300 cursor-pointer"
                      >
                        {p.buy} <ArrowRight size={14} />
                      </button>
                    ) : (
                      <span
                        data-testid={`program-soon-${prog.id}`}
                        className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-neutral-600"
                      >
                        <Lock size={14} /> {p.soon}
                      </span>
                    )}
                  </div>
                </div>
              </article>
            </StaggerItem>
          ))}
        </Stagger>

        <p className="mt-10 text-xs uppercase tracking-[0.2em] text-neutral-600 font-bold">
          {p.footnote}
        </p>
      </div>
    </section>
  );
};

export default Programs;
